import { ClearAll, Search } from "@mui/icons-material";
import { Card, CardContent, Typography, Container, Grid } from "@mui/material";
import { grey } from "@mui/material/colors";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { preloaderState } from "src/store/global/preloaderState";
//import { activeStepState } from '../Reservation/state/atoms'
import ButtonCustom from "../shared/components/buttons/ButtonCustom";
import FormSearch from "./FormSearch";
import {
  filterSearchSelectedState,
  hoursAvailableState,
  professionalsMatchCovenantState,
  professionalsNoMatchCovenantState,
} from "./state/atoms";
import useSEO from "src/Hooks/useSEO";
//import ReactGA from 'react-ga';
import ReactGA from "react-ga4";
import TabsSearch from "./TabsSearch";
import WhatsAppFab from "src/shared/components/buttons/WhatsAppFab";
import {
  valuesFormReservationGuestImagenologiaState,
  valuesFormReservationGuestState,
} from "src/Patient/state/atoms";

const Index = () => {
  const [loading, setLoading] = useState(false);
  const history = useNavigate();
  //const setActiveStep = useSetRecoilState(activeStepState);
  const setValuesFormGuest = useSetRecoilState(valuesFormReservationGuestState);
  const setValuesFormGuestImagenologia = useSetRecoilState(
    valuesFormReservationGuestImagenologiaState
  );
  const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
  const resetFilterSearchSelected = useResetRecoilState(
    filterSearchSelectedState
  );
  const setPreloader = useSetRecoilState(preloaderState);
  const resetProfessionalsMatchCovenant = useResetRecoilState(
    professionalsMatchCovenantState
  );
  const resetProfessionalsNoMatchCovenant = useResetRecoilState(
    professionalsNoMatchCovenantState
  );
  const resetHoursAvailable = useResetRecoilState(hoursAvailableState);

  //useTitle({title: 'Reserva de Hora'})
  useSEO({ title: "Reserva de Hora" });

  useEffect(() => {
    //setActiveStep(0);
    setPreloader(true);
    resetFilterSearchSelected();
    setValuesFormGuest((prev) => ({
      ...prev,
      uprRut: "",
    }));
    setValuesFormGuestImagenologia((prev) => ({
      ...prev,
      uprRut: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const eventGA = () => {
    let especialidad = filterSearchSelected.specialitySelected.value;
    especialidad = especialidad != "" ? `Especialidad: ${especialidad}` : "";
    let profesional = filterSearchSelected.professionalSelected.value;
    profesional = profesional != "" ? `| Profesional: ${profesional}` : "";
    let prevision = filterSearchSelected.covenantSelected.value;
    prevision = prevision != "" ? `| Previsión: ${prevision}` : "";
    ReactGA.event({
      category: "Buscar",
      action: `${especialidad} ${profesional} ${prevision}`,
    });
  };

  return (
    <Container
      style={{ maxWidth: 703 }}
      className="animate__animated animate__fadeIn"
    >
      {/* <Typography color={grey[700]} fontWeight={700} fontSize={24} pt={2}>
                FORMULARIO DE BÚSQUEDA
            </Typography>
            <Typography color={grey[400]} fontWeight={700} fontSize={12} pb={2}>
                FECHA MÁS PRÓXIMA
            </Typography> */}

      <TabsSearch />

      {/* <Card>
                <CardContent>
                    <FormSearch />
                </CardContent>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        p: 2,
                    }}
                >
                    <ButtonCustom
                        disabled={filterSearchSelected.professionalSelected.value === '' && filterSearchSelected.specialitySelected.value === '' ? true : false}
                        loading={loading}
                        color="secondary"
                        text="BUSCAR"
                        icon={<Search />}
                        style={{ marginRight: 15 }}
                        onClick={() => {
                            setLoading(true);
                            resetProfessionalsMatchCovenant();
                            resetProfessionalsNoMatchCovenant();
                            resetHoursAvailable();
                            eventGA();
                            setTimeout(() => {
                                history.push(`${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda`);
                            }, 1000)
                        }}
                    />
                    <ButtonCustom
                        color="default"
                        variant="contained"
                        text="LIMPIAR"
                        icon={<ClearAll />}
                        onClick={resetFilterSearchSelected}
                    />
                </Box>
            </Card> */}
      <Grid container direction={"row-reverse"}>
        <Grid item>
          <WhatsAppFab />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Index;
